import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { RxCross2 } from 'react-icons/rx';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { billValidationHeader } from 'app/constants/table-header-constants';
import ImageViewer from './ImageViewer';
import InvoiceForm from './InvoiceForm';
import useBillManagement from './useBillManagement';
import FilterModel from 'app/components/FilterModel';
import Dropdown from 'app/components/Dropdown';

const BillManagement = () => {
  const {
    isFiltering,
    fetchBillData,
    handleMallChange,
    mallList,
    storeList,
    error,
    modlopen,
    setOpenModel,
    modelvalues,
    handlemodelvalues,
    handleDelete,
    handleEdit,
    pageLoading,
    filteredData,
    navigate,
    handleNew,
    approveBillManagement,
    rejectBillManagement,
    rejectStatus,
    setrejectStatus,
    billActionInFlight,
    totalNumber,
    currentPage,
    setCurrentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    resetfilterModel,
    handleSubmit,
    handleFilterCancel,
    handleMallChangefilter,
    billrejectReasonDropdown,
    billrejectReson,
  } = useBillManagement();

  function changemm() {
    setOpenModel(false);
    setrejectStatus(false);
  }

  const modalContent = useMemo(
    () => (
      <Modal
        size='sm billtest'
        show={modlopen}
        // onHide={() => changemm}
        aria-labelledby='delete-popup'
        centered
      >
        <div className='modal-container cursor-pointer'>
          <span className='close-icon' onClick={changemm}>
            <RxCross2 />
          </span>
        </div>
        <Modal.Body className='text-center d-flex justify-content-around mt-5'>
          <div className='container_image_form modal-image-form'>
            <div className='left'>
              <ImageViewer modelvalues={modelvalues} />
            </div>
            <div className='right'>
              <InvoiceForm
                modelvalues={modelvalues}
                handlemodelvalues={handlemodelvalues}
                handleMallChange={handleMallChange}
                approveBillManagement={approveBillManagement}
                rejectBillManagement={rejectBillManagement}
                mallList={mallList}
                storeList={storeList}
                rejectStatus={rejectStatus}
                setrejectStatus={setrejectStatus}
                billActionInFlight={billActionInFlight}
                error={error}
                billrejectReasonDropdown={billrejectReasonDropdown}
                billrejectReson={billrejectReson}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    ),
    [
      modlopen,
      modelvalues,
      handlemodelvalues,
      handleMallChange,
      approveBillManagement,
      rejectBillManagement,
      mallList,
      storeList,
      rejectStatus,
      setrejectStatus,
      billActionInFlight,
      error,
    ]
  );

  return (
    <>
      <div className='cms-content__container billmanagement'>
        <PaginatedTable
          fulldata={filteredData}
          sectionObj={sectionObj}
          columns={billValidationHeader}
          data={filteredData}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          dataPerPage={dataPerPage}
          pageCountNumber={pageCount}
          totalNumber={totalNumber}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          pageLoading={pageLoading}
          navigate={navigate}
          handleNew={handleNew}
          isLoading={pageLoading}
          fetchData={fetchBillData}
          isFiltering={isFiltering}
          values={values}
        />

        {modalContent}
        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilterModel}
          >
            <>
              <div className='offcanvas-item'>
                <label>Contact Number:</label>
                <input
                  type='text'
                  value={values?.phoneNumber}
                  onChange={(e) =>
                    setValues({ ...values, phoneNumber: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>Bill Number:</label>
                <input
                  type='text'
                  value={values?.invoice_number}
                  onChange={(e) =>
                    setValues({ ...values, invoice_number: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <Dropdown
                  id={'mallId'}
                  label='Mall name*'
                  name='mallId'
                  options={mallList}
                  placeholder='Select Mall '
                  value={values?.mallId}
                  handleChange={handleMallChangefilter}
                  // isFieldHidden={hideFields}
                  errorText={error?.mallId}
                />
              </div>
              <div className='offcanvas-item'>
                <Dropdown
                  id={'storeId'}
                  label='Store name*'
                  name='storeId'
                  options={storeList}
                  value={values?.storeId}
                  placeholder='Select Store '
                  handleChange={(e) =>
                    setValues({ ...values, storeId: e.target.value })
                  }
                  errorText={error?.storeId}
                />
              </div>
              <label>Bill Date ranges:</label>
              <div className='offcanvas-item'>
                <label> Start Date</label>
                <input
                  type='date'
                  value={values?.invoice_dateStart}
                  max={values?.invoice_dateEnd}
                  onChange={(e) =>
                    setValues({ ...values, invoice_dateStart: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>End Date</label>
                <input
                  type='date'
                  value={values?.invoice_dateEnd}
                  min={values?.invoice_dateStart}
                  onChange={(e) =>
                    setValues({ ...values, invoice_dateEnd: e.target.value })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <Dropdown
                  id={'status'}
                  label='Bill Status*'
                  name='status'
                  options={[
                    { label: 'Under Review', value: 1 },
                    { label: 'Approved', value: 2 },
                    { label: 'Rejected', value: 3 },
                  ]}
                  placeholder='Select Status '
                  value={values?.billStatus}
                  handleChange={(e) =>
                    setValues({ ...values, billStatus: e.target.value })
                  }
                  // isFieldHidden={hideFields}
                />
              </div>
            </>
          </FilterModel>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default BillManagement;
